import React, { Component } from 'react';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import IntroPict from './../../assets/intro.jpg'
import './style.css'
const Intro=()=>{
    return(
        <section className="home d-flex flex-md-row flex-column-reverse" id="home">
            <div className='container-text'>
                <div className='home-text'>
                    <h4>
                        We are GetUp! <br/>We were born to be ready
                    </h4>
                </div>
            </div>
            <div className='home-img'>
                <div className="container-img">
                    <img src={IntroPict} alt=''/>
                </div>
            </div>
        </section>
    )
}

export default Intro